module.exports = __webpack_public_path__ + "static/wtgi-8e79b093a9cb6292d6d1370275cc2e88.jpg";